<template>
  <div>
    <div>
      <a
      v-if="this.disabled == false"
        v-show="modelValue || url"
        v-on:click="removeImage()"
        class="remove-img"
        style="
          cursor: pointer;
          position: absolute;
          right: 10px;
          top: 10px;
          z-index: 9;
        "
        ><img
          src="/img/close.png"
          width="16"
          style="margin-top: 500px justfy-content:right;"
      /></a>
      <label
        :for="url ? '' : 'input_' + compoentId"
        :class="
          disabled == false
            ? 'card mb-3 shadow-sm card-hover live-event-card text-center border-primary h-90 justify-content-center align-items-center'
            : 'card mb-3 shadow-sm card-hover live-event-card text-center border-primary h-90 justify-content-center align-items-center'
        "
        :style="
          disabled == false
            ? 'flex-direction: inherit;  height: 215px !important; width: 100%; '
            : 'flex-direction: inherit;  height: 215px !important; width: 100%;'
        ">
        <img
          style="
            flex-direction: inherit;
            height: 200px !important;
            width: 100%;
            margin-right: 10px;
            margin-left: 10px;
            object-fit: contain;
          "
          v-show="url"
          :src="url"
          @click="viewImage(url)"
          :id="compoentId"
          class="mg-fluid thumbnail-img"
          height="270"
          width="285" />
        <input
          v-if="disabled == false"
          type="file"
          name="img[]"
          class="file3"
          :id="'input_' + compoentId"
          @change="onChange($event)"
          accept="image/*"
          style="display: none" />
        <a v-if="disabled == false" v-show="!url" class="font-18"
          ><i class="fa fa-plus" aria-hidden="true"></i
        ></a>
      </label>
      <div
        style="
          text-align: center;
          width: 4211% !important;
          color: blue;
          margin-top: -18px;
          cursor: pointer;
        "
        v-show="url">
        <input
          type="file"
          name="img[]"
          class="file3"
          :id="'inputt_' + compoentId"
          @change="onChange($event, 'UPDATE')"
          accept="image/*"
          style="display: none" />
        <a
          v-if="this.disabled == false"
          class="font-18"
          @click="onChaneImage('inputt_' + compoentId)"
          >Change</a
        >
      </div>
      <!-- <label class="validation-msg font-6" v-show="!this.file"
        >Upload jpg/png image of size less than 10 MB</label
      > -->
    </div>
    <TextModal ref="imageCrooperModal">
      <div class="modal-header border-0 d-block text-center">
        <button
          type="button"
          class="close text-danger col-12"
          style="text-align: right; margin-top: -50px; margin-right: -28px"
          v-on:click="$refs.imageCrooperModal.closeModal()">
          <img src="/images/delete-btn.png" width="25" />
        </button>
        <cropper
          ref="cropper1"
          class="coordinates-cropper"
          :default-boundaries="boundaries"
          style="
            width: 450px;
            height: 300px !important;
            transition: opacity 300ms ease 0s;
            pointer-events: all;
          "
          :src="image.src"
          :auto-zoom="true"
          :stencil-props="{
            minAspectRatio: 10 / 20,
          }"
          @change="updateSize" />
        <a>
          <a class="mr-3" @click="rotate(90)">
            <i
              class="fa fa-repeat"
              style="font-size: 20px"
              aria-hidden="true"></i>
          </a>
          <a class="ml-3 mr-3" @click="rotate(-90)">
            <i
              class="fa fa-undo"
              style="font-size: 20px"
              aria-hidden="true"></i>
          </a>
        </a>
        <button
          type="button"
          class="fill-btn btn-brand-1 col-6 mt-3"
          v-on:click="cropImage()">
          Crop
        </button>
      </div>
    </TextModal>

    <TextModal ref="viewImage">
      <div
        class="modal-header border-0 d-block text-center"
        style="padding: 0 !important; position: relative">
        <a
          class="close text-danger col-12"
          style="
            text-align: right;
            opacity: 1;
            cursor: pointer;
            position: absolute;
            right: -10px;
            top: -16px;
          "
          v-on:click="$refs.viewImage.closeModal()">
          <img
            src="/images/close-btn.png"
            width="25"
            style="background: #fff; border-radius: 100px" />
        </a>
        <img :src="module_image" :id="compoentId" class="profile-pic" />
      </div>
    </TextModal>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import TextModal from "@/components/TextModal.vue";
export default {
  name: "ImagePicker",
  components: {
    Cropper,
    TextModal,
  },
  props: {
    id: {
      type: String,
      default: "spx_img_1",
    },
    modelValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.compoentId == "spx_img_1") {
      this.compoentId = "img_" + Math.floor(Math.random() * 1000);
    }
  },
  computed: {
    url() {
      return this.modelValue;
    },
  },
  data() {
    return {
      compoentId: this.id,
      selectFile: "",
      image: {
        src: "",
      },
      file: undefined,
      type: undefined,
      is_previous_image: false,
      obj: {},
      size: {
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    viewImage(url) {
      if (url) {
        this.module_image = url;
        this.$refs.viewImage.showModal("HIDE");
      }
    },
    rotate(angle) {
      this.$refs.cropper1.rotate(angle);
    },
    updateSize({ coordinates }) {
      this.size.width = Math.round(coordinates.width);
      this.size.height = Math.round(coordinates.height);
    },
    cropImage() {
      const result = this.$refs.cropper1.getResult();
      this.image.src = result.canvas.toDataURL(this.image.type);

      if (this.file) {
        this.is_previous_image = true;
      }

      // console.log("this.is_previous_image ",this.is_previous_image);

      this.file = this.dataURLtoFile(
        result.canvas.toDataURL(this.image.type),
        this.selectFile.name
      );
      const sizeInKB = this.selectFile.size / 1024; // Convert to KB
      if (sizeInKB > 400) {
        alert("Photo size should not exceed 400 KB");
        return;
      }
      this.$refs.imageCrooperModal.closeModal();
      if (this.type) {
        this.updateImage();
      } else {
        this.onUploadImage();
      }
    },
    onChaneImage(id) {
      document.getElementById(id).click();
    },
    onChange(e, type) {
      let files = e.target.files;
      if (type) {
        this.type = type;
      }
      this.selectFile = files[0];
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      // const sizeInKB = files[0].size / 1024; // Convert to KB
      // alert(sizeInKB);
      // if (sizeInKB > 400) {
      //   alert("Photo size should not exceed 400 KB");
      //   return;
      // }

      // const size = (files[0].size / 1024 / 1024).toFixed(2);
      // if (size > 1) {
      //   this.$notify({
      //     type: "error",
      //     text: "File must be less then 1 MB",
      //   });
      //   return;
      // }
      // this.selectFile = URL.createObjectURL(files[0]);
      // this.file = files[0];
      var reader = new FileReader();
      const blob = URL.createObjectURL(files[0]);

      this.image = {
        src: blob,
        type: files[0].type,
      };
      reader.readAsDataURL(e.target.files[0]);
      this.showCrooperPopup();
    },
    onUploadImage() {
      var add_new_block = true;
      if (this.is_previous_image) {
        add_new_block = false;
      }
      this.$emit("add-image", { add_new_block, image: this.image });
    },
    updateImage() {
      this.$emit("update-image", { image: this.image });
    },
    showCrooperPopup() {
      // this.$store.state.faqObj = {};
      this.$refs.imageCrooperModal.showModal();
      // this.$refs.faqForm.resetForm();
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    removeImage() {
      //Ticket No. 334 Profile Photos are not getting uploaded once user has deleted any photo.
      (this.selectFile = ""),
        (this.image = {
          src: "",
        });
      this.file = undefined;
      this.is_previous_image = false;
      this.$emitobj = {};

      this.$emit("removeImage");
    },
  },
};
</script>
